export default __webpack_public_path__ + "static/media/logo_mochi.c653abce.svg";